import { auditFlowManageConfig } from './auditFlowManage'

export const config = {
  ...auditFlowManageConfig,
}
